'use client';
import { jsx, jsxs } from 'react/jsx-runtime';
import t from 'tiny-warning';
import { useInternalOptionalSwanI18nContext } from '../../contexts/i18n/swan-i18n-provider.context.js';
import { useDeprecatedProps } from '../../hooks/use-deprecated-props.js';
import { getDeprecatedI18nPropMessage } from '../../hooks/use-required-i18n-props.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';
import { VisuallyHidden } from '../visually-hidden/visually-hidden.component.js';

function _define_property(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[t] = r, e;
}
function _object_spread(e) {
    for(var t = 1; t < arguments.length; t++){
        var r = null != arguments[t] ? arguments[t] : {}, n = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(r).filter(function(e) {
            return Object.getOwnPropertyDescriptor(r, e).enumerable;
        }))), n.forEach(function(t) {
            _define_property(e, t, r[t]);
        });
    }
    return e;
}
function ownKeys(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        r.push.apply(r, n);
    }
    return r;
}
function _object_spread_props(e, t) {
    return t = null != t ? t : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
        Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    }), e;
}
function _object_without_properties(e, t) {
    if (null == e) return {};
    var r, n, o = _object_without_properties_loose(e, t);
    if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        for(n = 0; n < i.length; n++)r = i[n], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
    }
    return o;
}
function _object_without_properties_loose(e, t) {
    if (null == e) return {};
    var r, n, o = {}, i = Object.keys(e);
    for(n = 0; n < i.length; n++)r = i[n], t.indexOf(r) >= 0 || (o[r] = e[r]);
    return o;
}
const PaginationStep = renderWithRef('PaginationStep', null, (o, c)=>{
    let { children: u, active: l = false, disabled: b = false, accessibleText: d, as: f, component: m, pageNumber: y } = o, O = _object_without_properties(o, [
        "children",
        "active",
        "disabled",
        "accessibleText",
        "as",
        "component",
        "pageNumber"
    ]), j = useInternalOptionalSwanI18nContext();
    useDeprecatedProps('PaginationStep', o, [
        {
            propName: 'disabled',
            instructions: 'This is deprecated without a replacement.'
        },
        {
            propName: 'accessibleText',
            instructions: getDeprecatedI18nPropMessage(j)
        }
    ]), t(!(j && !y), '[PaginationStep] Passing page number via "children" prop is deprecated. Use the "pageNumber" prop instead');
    let g = d;
    j && !g && (g = j.t('pagination-step.accessible-text-for-button', {
        pageNumber: null != y ? y : ''
    }));
    let _ = _object_spread_props(_object_spread({}, O), {
        disabled: ('button' === f || 'button' === m) && b,
        as: b && 'button' !== f && 'button' !== m && 'span' || f || m || 'a',
        'aria-current': !!l
    }), w = new Set([
        'swan-pagination-step'
    ]);
    return b && w.add('swan-pagination-step-disabled'), l && w.add('swan-pagination-step-active'), jsx("li", {
        children: jsxs(RenderComp, {
            root: "a",
            classNames: w,
            forwardedRef: c,
            props: _,
            children: [
                jsx(VisuallyHidden, {
                    children: g
                }),
                jsx("span", {
                    "aria-hidden": d || j ? 'true' : 'false',
                    children: y || u
                })
            ]
        })
    });
});

export { PaginationStep };
